import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import EditFamilyDetails from './components/FamilyDetails';

import { useDispatch, useSelector } from 'react-redux';

import {
  //   hobbies_list,
  //   sports_list,
  //   maritialStatus
  //   createAboutme
  // countryCodes,
  get_byID,
  occupationData,
  familyStatus,
  familyValue,
  familyType,
  siblings_maritial_Status,
  education_list
  // department_list,
  // cities_list,
  // signup
} from './redux/slice';
import { pageview } from '../../utilities/gtag';
const index = () => {
  useEffect(() => {
    document.title = 'Family details - Add family information';
  }, []);
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  const dispatch = useDispatch();

  const {
    // country_codes,
    Occupation_Data,
    // maritial_Status,
    family_Status,
    family_Value,
    family_Type,
    siblings_maritialStatus
    // get_hobbies_list,
    // get_sports_list
    // education_details
    // department_details,
    // city_details
  } = useSelector((state) => state.editprofile);

  const { user_data } = useSelector((state) => state.listDashboard);
  const { education_details } = useSelector((state) => state.editeducation);

  // console.log('user_data', user_data);

  useEffect(() => {
    get_listby_id();
    // get_hobbies();
    // get_sports();
    // get_maritialStatus();

    // get_countryCodes();
    get_occupation();
    get_familyStatus();
    get_familyValue();
    get_familyType();
    get_siblings_maritialStatus();
    get_education_details();
    // get_department_details();
    // get_cities();
  }, []);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  const get_listby_id = () => {
    const payload = userId;
    dispatch(get_byID(payload));
  };
  const get_occupation = () => {
    dispatch(occupationData());
  };
  const get_familyStatus = () => {
    dispatch(familyStatus());
  };
  const get_familyValue = () => {
    dispatch(familyValue());
  };
  const get_familyType = () => {
    dispatch(familyType());
  };
  const get_siblings_maritialStatus = () => {
    dispatch(siblings_maritial_Status());
  };
  // const get_hobbies = () => {
  //   const payload = { type: 'hobby' };
  //   dispatch(hobbies_list(payload));
  // };
  // const get_sports = () => {
  //   const payload = { type: 'sport' };
  //   dispatch(sports_list(payload));
  // };
  const get_education_details = () => {
    dispatch(education_list());
  };
  // const get_department_details = () => {
  //   dispatch(department_list());
  // };
  // const get_cities = () => {
  //   dispatch(cities_list());
  // };

  //   const onsubmit = (payload) => {
  //     console.log('onsubmit', payload);
  //     dispatch(createAboutme(payload));
  //   };

  return (
    <>
      <Layout sider={true}>
        <EditFamilyDetails
          //   get_hobbies_list={get_hobbies_list}
          //   get_sports_list={get_sports_list}
          //   maritial_Status={maritial_Status}
          Occupation_Data={Occupation_Data}
          family_Status={family_Status}
          family_Value={family_Value}
          family_Type={family_Type}
          siblings_maritialStatus={siblings_maritialStatus}
          onsubmit={onsubmit}
          user_data={user_data}
          education_list={education_details}
        />
      </Layout>
    </>
  );
};

export default index;
